export default "__VITE_ASSET__DGoh1Mcd__"